// extracted by mini-css-extract-plugin
export default {"container":"preview-card_container__b+KyI","image":"preview-card_image__pmWrh","text":"preview-card_text__Ld16O"};